// Copyright (c) 2016 Deere & Company

import './registration-history-panel.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import RegistrationHistory from '@deere/cps-it.warranty-model-factory/lib/registration-history';
import RegistrationHistoryList from './registration-history-list';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const RegistrationHistoryPanel = props => {

    const numberOfRegistrations = ` (${props.registrationHistory.length})`;

    const title = (
        <span>
            <FormattedMessage id='REGISTRATION_HISTORY'/>{numberOfRegistrations}
        </span>
    );

    const body = (
        <RegistrationHistoryList
            actions={props.actions}
            isRegistrationFormNotAllowed={props.isRegistrationFormNotAllowed}
            language={props.language}
            registrationHistory={props.registrationHistory}
            security={props.security}
            user={props.user}
        />
    );

    return (
        <Accordion
            accordionId='customer-history-panel-accordion'
            body={body}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={title}
        />
    );

};

RegistrationHistoryPanel.displayName = 'RegistrationHistoryPanel';
RegistrationHistoryPanel.propTypes = {
    actions: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    isRegistrationFormNotAllowed: PropTypes.bool.isRequired,
    language: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    registrationHistory: PropTypes.arrayOf(PropTypes.instanceOf(RegistrationHistory)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationHistoryPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/registration-history-panel.js